import CollectionButton from './collectionButton'

export default CollectionButton
